import { useEffect, useState } from 'preact/hooks'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'

const useProductForm = () => {
  const { productState } = window
  const { initProduct } = productState
  const [currentVariant, setCurrentVariant] = useState(
    initProduct.variants.find((variant) => variant.id === initProduct.initVariantId) || {}
  )
  const [properties, setProperties] = useState({})
  const [sellingPlanId, setSellingPlanId] = useState(null)
  const [currentVariantPrice, setCurrentVariantPrice] = useState(currentVariant.price)

  const updateCurrentVariant = (variant) => {
    if (currentVariant.id === variant.id) return
    setCurrentVariant(variant)
  }

  useEffect(() => {
    globalEmitter.on(emitterProps.product.updateVariant, updateCurrentVariant)

    return () => {
      globalEmitter.off(emitterProps.product.updateVariant, updateCurrentVariant)
    }
  }, [])

  return {
    productState,
    initProduct,
    currentVariant,
    updateCurrentVariant,
    properties,
    setProperties,
    sellingPlanId,
    setSellingPlanId,
    currentVariantPrice,
    setCurrentVariantPrice
  }
}

export default useProductForm
